import { generateText } from '@tiptap/core';
import { WidgetId } from 'types/idTypes';
import { WidgetType } from 'types/widget.types';
import { extensions } from 'widgets/TextBasedWidgets/TextWidget/TextWidgetExtensions';
import { WIDGET_LABEL_MAP } from 'widgets/Widget.config';
import { getWidgetTypeFromId } from 'widgets/Widget.helpers';

/**
 * Generates the label to be announced by screen readers
 * @param widgetId ID of the widget
 * @param data the widget's data
 * @returns label
 */
export function getWidgetLabelInformation(
  widgetId: WidgetId,
  // TODO: refactor this its too coupled with the text widget
  proseMirrorData: any,
  textTag: string,
  altText: string,
): {
  widgetLabel: string;
  widgetDescription: string;
} {
  const widgetType = getWidgetTypeFromId(widgetId);
  let widgetLabel, widgetDescription;

  switch (widgetType) {
    case WidgetType.Text:
      try {
        const textContent = generateText(proseMirrorData, extensions);

        widgetLabel = `${textTag} text widget`;
        widgetDescription = textContent;
      } catch (error) {
        console.error(error);
        widgetLabel = '';
        widgetDescription = '';
      }

      break;
    case WidgetType.Icon:
    case WidgetType.BasicShape:
    case WidgetType.Line:
    case WidgetType.Image:
    case WidgetType.AreaChart:
    case WidgetType.BarChart:
    case WidgetType.ColumnChart:
    case WidgetType.HalfPieChart:
    case WidgetType.HistogramChart:
    case WidgetType.LineChart:
    case WidgetType.PieChart:
    case WidgetType.StackedAreaChart:
    case WidgetType.StackedBarChart:
    case WidgetType.StackedColumnChart:
    case WidgetType.WordCloudChart:
      widgetLabel = WIDGET_LABEL_MAP[widgetType] ?? '';
      widgetDescription = altText || '';
      break;
    default:
      widgetLabel = '';
      widgetDescription = '';
  }

  return {
    widgetLabel,
    widgetDescription,
  };
}
